export default "__VITE_ASSET__1baf3fa9__"